/* src/app/components/control-module/step-tabber/step-tabber.component.css */
table.filter-table td {
  padding: 2px 10px 1px 10px;
  vertical-align: top;
}
.w-20 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 20% !important;
  flex: 0 0 20% !important;
  max-width: 20%;
}
.evaluation-section-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px;
  padding-left: 10px;
  border-left: 4px solid var(--navy-600);
}
.evaluation-divider {
  margin: 28px 0;
  border: 0;
  border-top: 2px solid var(--border);
  opacity: 1;
}
.evaluation-table {
  width: 100%;
  font-size: 14px;
}
.evaluation-table th {
  white-space: nowrap;
}
.evaluation-table .actions-cell {
  white-space: nowrap;
}
.evaluation-detailed-table th {
  text-align: center;
  vertical-align: middle;
}
.evaluation-detailed-table td {
  white-space: nowrap;
}
/*# sourceMappingURL=step-tabber.component.css.map */
